module.exports = __webpack_public_path__ + "static/6-b830370305ac317a06ae338cbbac1886.jpg";